/**
 * Legacy PDFButton — now delegates to the unified ReportButton.
 * Detects `/pdf/module/{collection}` pattern in endpoint and switches to the
 * multi-format report endpoint automatically. Falls back to legacy behavior
 * for special endpoints (one-pager, global, conagua, management-review).
 */
import ReportButton from "./ReportButton";

export default function PDFButton({
  endpoint,
  filename = "reporte.pdf",
  label = "Generar Reporte PDF",
  extraBody = {},
  testId = "pdf-btn",
}) {
  // Detect /pdf/module/{collection} → use unified report endpoint
  const m = /^\/pdf\/module\/([a-zA-Z0-9_]+)$/.exec(endpoint || "");
  if (m) {
    const collection = m[1];
    return (
      <ReportButton
        collection={collection}
        filename={filename.replace(/\.pdf$/i, "")}
        label={label.replace(/Generar Reporte /i, "Reporte ")}
        extraBody={extraBody}
        testId={testId}
      />
    );
  }
  // Non-module endpoints (one-pager, global, conagua, management-review): keep legacy single-PDF flow.
  return (
    <ReportButton
      endpoint={endpoint}
      filename={filename.replace(/\.pdf$/i, "")}
      label={label}
      extraBody={extraBody}
      testId={testId}
    />
  );
}
